import PDFList from "components/pdfList";
import SEO from "components/SEO";
import { fetchPost } from "functions";
import useTranslation from "translations/hooks/useTranslation";

const FinancialMedicalTransactions = ({ pageData, lang }) => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={t("financialAndMedicalTransactions")}
        description={t("financialAndMedicalTransactionsDesc")}
      />
      <PDFList
        lang={lang}
        pageData={pageData}
        title={"financialAndMedicalTransactions"}
        breadcrumb={"financialAndMedicalTransactions"}
        desc={"financialAndMedicalTransactionsDesc"}
      />
    </>
  );
};

export default FinancialMedicalTransactions;

export async function getServerSideProps(context) {
  let { lang } = context?.query;

  let pageData = await fetchPost({
    apiName: `financial-medical-transactions/get`,
  });

  return {
    props: {
      lang,
      pageData: pageData?.response,
    },
  };
}
